import api from './index';

const ResponsiblesService = {
  // Listar responsáveis da conta do usuário
  getResponsibles: async () => {
    try {
      console.log('ResponsiblesService - Buscando responsáveis...');
      const response = await api.get('/api/responsibles');
      console.log('ResponsiblesService - Responsáveis obtidos:', response.data);
      return response.data;
    } catch (error) {
      console.error('ResponsiblesService - Erro ao buscar responsáveis:', error);
      throw error;
    }
  },

  // Buscar responsável específico por ID
  getResponsible: async (id) => {
    try {
      console.log('ResponsiblesService - Buscando responsável:', id);
      const response = await api.get(`/api/responsibles/${id}`);
      console.log('ResponsiblesService - Responsável obtido:', response.data);
      return response.data;
    } catch (error) {
      console.error('ResponsiblesService - Erro ao buscar responsável:', error);
      throw error;
    }
  },

  // Criar novo responsável
  createResponsible: async (responsibleData) => {
    try {
      console.log('ResponsiblesService - Criando responsável:', responsibleData);
      const response = await api.post('/api/responsibles', responsibleData);
      console.log('ResponsiblesService - Responsável criado:', response.data);
      return response.data;
    } catch (error) {
      console.error('ResponsiblesService - Erro ao criar responsável:', error);
      throw error;
    }
  },

  // Atualizar responsável
  updateResponsible: async (id, responsibleData) => {
    try {
      console.log('ResponsiblesService - Atualizando responsável:', id, responsibleData);
      const response = await api.put(`/api/responsibles/${id}`, responsibleData);
      console.log('ResponsiblesService - Responsável atualizado:', response.data);
      return response.data;
    } catch (error) {
      console.error('ResponsiblesService - Erro ao atualizar responsável:', error);
      throw error;
    }
  },

  // Excluir responsável
  deleteResponsible: async (id) => {
    try {
      console.log('ResponsiblesService - Excluindo responsável:', id);
      const response = await api.delete(`/api/responsibles/${id}`);
      console.log('ResponsiblesService - Responsável excluído:', response.data);
      return response.data;
    } catch (error) {
      console.error('ResponsiblesService - Erro ao excluir responsável:', error);
      throw error;
    }
  },

  // Upload de documento do responsável
  uploadDocument: async (responsibleId, docType, file) => {
    try {
      console.log('ResponsiblesService - Upload de documento:', { responsibleId, docType, fileName: file.name });
      const formData = new FormData();
      formData.append('document', file);
      formData.append('doc_type', docType);

      const response = await api.post(`/api/responsibles/${responsibleId}/documents`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      console.log('ResponsiblesService - Documento enviado:', response.data);
      return response.data;
    } catch (error) {
      console.error('ResponsiblesService - Erro ao enviar documento:', error);
      throw error;
    }
  },

  // Listar documentos do responsável
  getDocuments: async (responsibleId) => {
    try {
      console.log('ResponsiblesService - Buscando documentos do responsável:', responsibleId);
      const response = await api.get(`/api/responsibles/${responsibleId}/documents`);
      console.log('ResponsiblesService - Documentos obtidos:', response.data);
      return response.data;
    } catch (error) {
      console.error('ResponsiblesService - Erro ao buscar documentos:', error);
      throw error;
    }
  },

  // Remover documento do responsável
  deleteDocument: async (responsibleId, documentId) => {
    try {
      console.log('ResponsiblesService - Removendo documento:', { responsibleId, documentId });
      const response = await api.delete(`/api/responsibles/${responsibleId}/documents/${documentId}`);
      console.log('ResponsiblesService - Documento removido:', response.data);
      return response.data;
    } catch (error) {
      console.error('ResponsiblesService - Erro ao remover documento:', error);
      throw error;
    }
  },

  // Utilitários para status
  getStatusBadgeClass: (status) => {
    switch (status) {
      case 'approved':
        return 'bg-success';
      case 'rejected':
        return 'bg-danger';
      case 'pending_approval':
        return 'bg-warning';
      case 'pending_validation':
        return 'bg-warning';
      case 'pending':
        return 'bg-warning';
      default:
        return 'bg-secondary';
    }
  },

  getStatusText: (status) => {
    switch (status) {
      case 'approved':
        return 'Aprovado';
      case 'rejected':
        return 'Rejeitado';
      case 'pending_approval':
        return 'Aguardando Aprovação';
      case 'pending_validation':
        return 'Aguardando Aprovação';
      case 'pending':
        return 'Aguardando Aprovação';
      default:
        return 'Indefinido';
    }
  },

  // Validar CPF ou CNPJ
  validateCPF: (document) => {
    if (!document) return false;
    document = document.replace(/[^\d]+/g, '');
    
    if (document.length === 11) {
      // Validação CPF
      if (/^(\d)\1{10}$/.test(document)) return false;
      
      let sum = 0;
      for (let i = 0; i < 9; i++) {
        sum += parseInt(document.charAt(i)) * (10 - i);
      }
      let remainder = sum % 11;
      let digit1 = remainder < 2 ? 0 : 11 - remainder;
      
      if (parseInt(document.charAt(9)) !== digit1) return false;
      
      sum = 0;
      for (let i = 0; i < 10; i++) {
        sum += parseInt(document.charAt(i)) * (11 - i);
      }
      remainder = sum % 11;
      let digit2 = remainder < 2 ? 0 : 11 - remainder;
      
      return parseInt(document.charAt(10)) === digit2;
    } else if (document.length === 14) {
      // Validação CNPJ (básica)
      if (/^(\d)\1{13}$/.test(document)) return false;
      return true; // Para simplificar, aceita qualquer CNPJ com 14 dígitos
    }
    
    return false;
  },

  // Formatar CPF
  formatCPF: (cpf) => {
    if (!cpf) return '';
    cpf = cpf.toString().replace(/[^\d]/g, '');
    if (cpf.length === 11) {
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else if (cpf.length === 14) {
      // Formato CNPJ
      return cpf.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    return cpf;
  },

  // Formatar CNPJ (alias para formatCPF que já trata CNPJ)
  formatCNPJ: (cnpj) => {
    if (!cnpj) return '';
    cnpj = cnpj.toString().replace(/[^\d]/g, '');
    if (cnpj.length === 14) {
      return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    return cnpj;
  },

  // Formatar telefone
  formatPhone: (phone) => {
    if (!phone) return '';
    phone = phone.toString().replace(/[^\d]/g, '');
    if (phone.length === 11) {
      return phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    } else if (phone.length === 10) {
      return phone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }
    return phone;
  }
};

export default ResponsiblesService;
